import { render, staticRenderFns } from "./PaymentBillingData.vue?vue&type=template&id=0c7067c5"
import script from "./PaymentBillingData.vue?vue&type=script&lang=js"
export * from "./PaymentBillingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports